import { render } from "./index.vue?vue&type=template&id=511630c1&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=511630c1&lang=scss&scoped=true"

import exportComponent from "/spug/spug_api/repos/119_10566_20260928180206/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511630c1"],['__file',"src/views/data-manage/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "511630c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('511630c1', __exports__)) {
    console.log('reload')
    api.reload('511630c1', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=511630c1&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('511630c1', render)
  })

}


export default __exports__